import { render } from "./Realname.vue?vue&type=template&id=6137fb41&scoped=true"
import script from "./Realname.vue?vue&type=script&lang=js"
export * from "./Realname.vue?vue&type=script&lang=js"

import "./Realname.vue?vue&type=style&index=0&id=6137fb41&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6137fb41"]])

export default __exports__